var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreatmentSummaryCycles = function SvgTreatmentSummaryCycles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M13.18 18.2c2.92 2.51 8.24 5 11 .94.22-.33.39-.19.27.17-2.29 6.81-10.14 7.34-15.38 2.94L7.2 23.97a.75.75 0 0 1-.49.19.68.68 0 0 1-.43-.15.69.69 0 0 1-.29-.58v-7.32a1 1 0 0 1 .96-1h7.33a.75.75 0 0 1 .33.07.7.7 0 0 1 .25.22.71.71 0 0 1 0 .92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M7.53 12.7c2.29-6.81 10.14-7.35 15.38-3l1.87-1.71a.7.7 0 0 1 .49-.19.8.8 0 0 1 .44.14.73.73 0 0 1 .29.58v7.33a1 1 0 0 1-.29.7 1 1 0 0 1-.7.29h-7.33a.7.7 0 0 1-.32-.08.75.75 0 0 1-.26-.21.74.74 0 0 1 0-.93l1.67-1.87c-2.92-2.5-8.24-4.95-11-.93-.19.37-.36.29-.24-.12"
  })));
};
export default SvgTreatmentSummaryCycles;